import styled from 'styled-components'

import cancelGlyph from 'iconoir/icons/cancel.svg'

export const CloseIcon = styled(cancelGlyph)`
  stroke-width: 2;
`
